var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypePng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8554 6.56533C18.1174 6.56463 17.4097 6.27474 16.8879 5.75929C16.366 5.24385 16.0725 4.54495 16.0717 3.816V0H3.63285C2.66935 0 1.74533 0.378023 1.06404 1.0509C0.382748 1.72378 0 2.6364 0 3.588V25.2173C0.00143078 26.168 0.384806 27.0793 1.06594 27.751C1.74708 28.4227 2.67029 28.8 3.63285 28.8H18.5652C19.528 28.8 20.4514 28.4225 21.1326 27.7505C21.8138 27.0785 22.197 26.1669 22.198 25.216V6.56533H18.8554Z",
    fill: "#2563EB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 6.56533H18.8555C18.1174 6.56463 17.4098 6.27474 16.8879 5.75929C16.366 5.24385 16.0725 4.54495 16.0718 3.816V0L22.1981 6.56533Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8319 22.7466H7.95155C6.75414 22.7466 5.78345 23.7053 5.78345 24.8879V29.8586C5.78345 31.0412 6.75414 31.9999 7.95155 31.9999H24.8319C26.0294 31.9999 27 31.0412 27 29.8586V24.8879C27 23.7053 26.0294 22.7466 24.8319 22.7466Z",
    fill: "#2563EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.673 28.4492V29.4186H9.65649V28.4492H10.673Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1662 28.0132V29.4185H11.1833V25.4092H12.7737C13.257 25.4092 13.6246 25.5274 13.8766 25.7638C14.0045 25.8878 14.1044 26.037 14.1698 26.2018C14.2352 26.3665 14.2646 26.5431 14.256 26.7198C14.2602 26.953 14.2015 27.1832 14.0858 27.3865C13.9686 27.5855 13.7937 27.7453 13.5837 27.8452C13.3311 27.9642 13.0534 28.0218 12.7737 28.0132H12.1662ZM13.257 26.7198C13.257 26.3643 13.0599 26.1865 12.6657 26.1865H12.1662V27.2305H12.6657C13.0599 27.2341 13.257 27.0638 13.257 26.7198Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3438 29.4185H17.3623L15.718 26.9572V29.4185H14.7366V25.4092H15.718L17.361 27.8932V25.4092H18.3424L18.3438 29.4185Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1791 25.7334C22.5067 25.9755 22.7268 26.3333 22.7934 26.732H21.7539C21.6857 26.5892 21.5762 26.4695 21.4393 26.388C21.2846 26.2974 21.1075 26.2513 20.9277 26.2547C20.788 26.249 20.6488 26.2736 20.5198 26.3268C20.3908 26.38 20.2752 26.4606 20.1811 26.5627C19.9839 26.7968 19.8836 27.0959 19.9003 27.4C19.9003 27.7814 19.9989 28.0743 20.196 28.2787C20.3067 28.3849 20.4388 28.4671 20.5836 28.5199C20.7285 28.5727 20.8829 28.595 21.037 28.5854C21.2573 28.5891 21.4728 28.5222 21.6513 28.3947C21.8331 28.2603 21.9642 28.0698 22.0239 27.8534H20.7846V27.156H22.846V28.1334C22.7662 28.3718 22.6411 28.5931 22.4775 28.7854C22.3007 28.9923 22.0805 29.1588 21.8322 29.2734C21.5506 29.4018 21.2432 29.4656 20.9331 29.46C20.5563 29.4694 20.1836 29.3802 19.8531 29.2014C19.5506 29.0338 19.3042 28.7827 19.1443 28.4787C18.9732 28.1513 18.8874 27.787 18.8946 27.4187C18.8865 27.0481 18.9723 26.6815 19.1443 26.352C19.304 26.0488 19.5492 25.7978 19.8504 25.6294C20.1762 25.4521 20.5437 25.3633 20.9155 25.372C21.3657 25.3502 21.8104 25.4774 22.1791 25.7334Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38457 8.896H5.52832V10.7293H7.38457V8.896Z",
    fill: "#2563EB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24199 10.7295H7.38574V12.5628H9.24199V10.7295Z",
    fill: "#2563EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0984 8.896H9.24219V10.7293H11.0984V8.896Z",
    fill: "#2563EB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9546 10.7295H11.0984V12.5628H12.9546V10.7295Z",
    fill: "#2563EB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8135 8.896H12.9573V10.7293H14.8135V8.896Z",
    fill: "#2563EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6697 10.7295H14.8135V12.5628H16.6697V10.7295Z",
    fill: "#2563EB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38457 12.5601H5.52832V14.3934H7.38457V12.5601Z",
    fill: "#2563EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24199 14.3936H7.38574V16.2269H9.24199V14.3936Z",
    fill: "#2563EB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0984 12.5601H9.24219V14.3934H11.0984V12.5601Z",
    fill: "#2563EB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9546 14.3936H11.0984V16.2269H12.9546V14.3936Z",
    fill: "#2563EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8135 12.5601H12.9573V14.3934H14.8135V12.5601Z",
    fill: "#2563EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6697 14.3936H14.8135V16.2269H16.6697V14.3936Z",
    fill: "#2563EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38457 16.2412H5.52832V18.0745H7.38457V16.2412Z",
    fill: "#2563EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24199 18.0747H7.38574V19.908H9.24199V18.0747Z",
    fill: "#2563EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0984 16.2412H9.24219V18.0745H11.0984V16.2412Z",
    fill: "#2563EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9546 18.0747H11.0984V19.908H12.9546V18.0747Z",
    fill: "#2563EB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8135 16.2412H12.9573V18.0745H14.8135V16.2412Z",
    fill: "#2563EB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6697 18.0747H14.8135V19.908H16.6697V18.0747Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypePng);
export default __webpack_public_path__ + "static/media/Type=PNG.e80c66f551d42b5ffc779d88a0c59d3d.svg";
export { ForwardRef as ReactComponent };